const findNameCollision = (state) => (layerName, skipId, clone = false) => {
  const x = state.layersBase.filter(e => e.name.replace(/\((.+)\)/g, '').trim() === layerName &&
    (clone ? true : e.ObjectId !== skipId))
  return x.length > 0 ? `${layerName} (${x.length + 1})` : `${layerName}`
}
const getBaseLayer = (state) => { return state.baseLayer }
const getBaseLayers = (state) => { return state.layersBase }
const getLayer = (state) => (layerId) => {
  const idx = state.layersBase.findIndex(e => e.ObjectId === layerId)
  return idx !== -1 ? state.layersBase[idx] : null
}
const getBasePk = (state) => { return state.basePk }
const getDraft = (state) => { return state.activeLayerId !== null ? state.layers[state.activeLayerId].draft : null }
const getLayerDraft = (state) => (layerId) => {
  const layer = state.layers[layerId]
  return layer ? layer.draft : null
}
const getTargetLayer = (state) => { return state.targetLayer }
const getTargetPk = (state) => { return state.targetPk }
const getGeoPopLevels = (state) => {
  return state.geoPopLevels
}
const getStyle = (state) => (id) => {
  const item = state.layerList.find(item => item.id === id)
  const layer = item.object.layer
  const dataVis = layer.jbData.config.datavis
  return dataVis.style
}
const getNewlayer = (state) => {
  return state.newLayer
}
const getStatusLayer = (state) => {
  return state.statusLayer
}
const getLoading = (state) => {
  return state.loading
}
const getLayersMenu = (state) => {
  return state.layersMenu
}
const getEnvironmentDataMenu = (state) => {
  return state.environmentDataMenu
}
const getVisibleLayers = (state) => {
  return state.layersBase.filter(x => x.Enabled)
}

export default {
  findNameCollision,
  getDraft,
  getLayer,
  getLayerDraft,
  getEnvironmentDataMenu,
  getLayersMenu,
  getBaseLayer,
  getBaseLayers,
  getBasePk,
  getGeoPopLevels,
  getLoading,
  getNewlayer,
  getStyle,
  getStatusLayer,
  getTargetLayer,
  getTargetPk,
  getVisibleLayers
}
